import React, { Component } from "react";
import * as s from "./Player.module.scss";
import { IImage } from "resource-centre-theme/src/models";
import { BackgroundImage } from "resource-centre-theme/src/views/shared/components";
import { Icons } from "resource-centre-theme/src/libs/assets";

interface Props {
  video: string;
  poster: IImage;
}

interface State {
  playing: boolean;
}

export class Player extends Component<Props, State> {
  private playRef = React.createRef<any>();

  constructor(props) {
    super(props);
    this.state = {
      playing: false,
    };
  }

  togglePlaying = () => {
    this.setState({ playing: !this.state.playing });
  };

  playVideo = () => {
    this.playRef.current.play();
    this.togglePlaying();
  };

  render() {
    const { video, poster } = this.props;
    const { playing } = this.state;
    const classes = [s.playerContainer];

    if (playing) classes.push(s.playing);

    return (
      <div className={classes.join(" ")}>
        <div className={s.videoOverlay}>
          <img
            src={Icons.play_button}
            className={s.playButton}
            onClick={this.playVideo}
          />
          <BackgroundImage className={s.image} image={poster} />
        </div>
        <video ref={this.playRef} controls>
          <source src={video} type="video/mp4" />
        </video>
      </div>
    );
  }
}
